module.exports = __webpack_public_path__ + "img/shibai.d7e36f9c.png";